import React, {useEffect, useState} from 'react';
import {Modal} from 'antd';
import {observer} from 'mobx-react-lite';
import {useNavigate} from 'react-router-dom';

import {useStore} from '@/app/providers/StoreProvider';
import {Loading} from '@/shared/ui/Loading';
import {useCloudFlag} from '@/shared/hooks/useCloudFlag';

import {TeamList} from '@/entities/team/ui/TeamList';
import {MyTeam} from '@/entities/team/ui/MyTeam';
import {SearchTeams} from '@/entities/team/ui/SearchTeams';

import ImgTeamBanner from '@/shared/pictures/team_banner.png';
import ImgInfo from '@/shared/pictures/Info.svg';
import ImgClose from '@/shared/pictures/close.svg';
import ImgFirstTeam from '@/shared/pictures/first_team.png';
import ImgPucks from '@/shared/pictures/pucks_team.png';


export enum TeamTabType {
    TEAM_GLOBAL = 'Все команды',
    MY = 'Моя команда',
    SEARCH = 'Поиск'
}

export const TeamsPage = observer(() => {
    const navigate = useNavigate();

    const [tab, setTab] = useState<TeamTabType>(TeamTabType.TEAM_GLOBAL);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [firstModal, setFirstModal, loading] = useCloudFlag('firstModal', true);
    const handleCancelFirstLast = () => {
        setFirstModal(false);
        setLastModal(false);
    };
    const [lastModal, setLastModal] = useState(false);
    const nextModal = () => {
        setFirstModal(false);
        setLastModal(true);
    };


    const {teamStore,ratingStore} = useStore();
    const {loadingTeams} = teamStore;
    useEffect(() => {
        ratingStore.getRating('TEAM_GLOBAL');
        return () => {
            ratingStore.resetRating();
        }
    }, []);


    if (loadingTeams || loading) return <Loading/>

    return (
        <div className='teams-page'>
            <div className="container">

                <div className='teams-banner'>
                    <h2 className='teams-banner_name'>Команды</h2>
                    <img className='teams-banner_img' src={ImgTeamBanner} alt="pucks-img"/>
                    <img className='teams-banner_info' src={ImgInfo} alt="info" onClick={() => setIsModalOpen(true)}/>
                </div>

                <div className='tabs'>
                    <div className={`tab ${tab === TeamTabType.TEAM_GLOBAL ? 'active' : ''}`}
                         onClick={() => setTab(TeamTabType.TEAM_GLOBAL)}>{TeamTabType.TEAM_GLOBAL}</div>
                    <div className={`tab ${tab === TeamTabType.MY ? 'active' : ''}`}
                         onClick={() => setTab(TeamTabType.MY)}>{TeamTabType.MY}</div>
                    <div className={`tab ${tab === TeamTabType.SEARCH ? 'active' : ''}`}
                         onClick={() => setTab(TeamTabType.SEARCH)}>{TeamTabType.SEARCH}</div>
                </div>

                {tab === TeamTabType.TEAM_GLOBAL && <TeamList/>}
                {tab === TeamTabType.MY && <MyTeam searchClick={() => setTab(TeamTabType.SEARCH)}/>}
                {tab === TeamTabType.SEARCH && <SearchTeams/>}


                <Modal
                    title={null}
                    closable={{'aria-label': 'Custom Close Button'}}
                    open={isModalOpen}
                    footer={null}
                    closeIcon={<img src={ImgClose} onClick={handleCancel}/>}
                >
                    <div className='modal'>
                        <div className='modal_body'>
                            <h3 className='modal_title'>Что такое команды?</h3>
                            <p className='modal_text'>Раздел “Команды” позволяет участвовать в “Битве команд” , получать
                                бонусы или создавать свою команду! </p>
                        </div>

                        <div className='modal_buttons'>
                            <button type='button' className='modal_button button_gray' onClick={handleCancel}>Закрыть
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    title={null}
                    open={firstModal}
                    footer={null}
                    closeIcon={null}
                >
                    <div className='modal'>
                        <div className='modal_body'>
                            <img className='modal_img' src={ImgFirstTeam} alt="first"/>
                            <h3 className='modal_title'>Добро пожаловать в раздел Команды!</h3>
                            <p className='modal_text'> Тут вы можете участвовать в “Битве команд”, получать бонусы или
                                создать свою команду! </p>
                        </div>
                        <div className='modal_buttons'>
                            <button type='button' className='modal_button button_gray'
                                    onClick={() => (nextModal())}>Далее
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    title={null}
                    closable={{'aria-label': 'Custom Close Button'}}
                    open={lastModal}
                    footer={null}
                    closeIcon={<img src={ImgClose} onClick={handleCancelFirstLast}/>}
                >
                    <div className='modal'>
                        <div className='modal_body'>
                            <img className='modal_img' src={ImgPucks} alt="first" style={{maxWidth: 150}}/>
                            <h3 className='modal_title'>Получайте бонусы!</h3>
                            {/* <p className='modal_text'> Ускоренная регенерация энергии — <span className='modal_text-blue'>20</span> часов у участников, <span className='modal_text-blue'>18</span> часов у лидера команды.</p> */}
                            <p className='modal_text'> Ускоренная регенерация энергии — <span
                                className='modal_text-blue'>20</span> часов у всех участников команды.</p>
                        </div>
                        <div className='modal_buttons'>
                            <button type='button' className='modal_button button_gray'
                                    onClick={() => (setTab(TeamTabType.SEARCH), handleCancelFirstLast())}>Найти команду
                            </button>
                            <button type='button' className='modal_button button_blue'
                                    onClick={() => (setFirstModal(false), navigate('/team-create'))}>Создать свою команду
                            </button>
                        </div>
                    </div>
                </Modal>

            </div>
        </div>
    );
});
